import { useCallback } from "react";
import { ENVIRONMENT } from "../../../env";

type UseNewMessageArgs = {
    onOpenConversation: () => void;
};

export const useNewMessage = ({ onOpenConversation }: UseNewMessageArgs) => {
    const handleViewConversation = useCallback(() => {
        onOpenConversation();
    }, [onOpenConversation]);

    const handleListen = useCallback(() => {
        if (ENVIRONMENT === "DEV") console.log("Listen clicked");
    }, []);

    return {
        handleViewConversation,
        handleListen,
    };
};
